import React from 'react';
import { MsgTransaction } from '../../../../types/rest/assetCatalogTypes';
import { MockService } from '../../../../types/rest/mockServiceTypes';
import { MockServiceTemplate } from '../../../../store/mockServiceTemplates/mockServiceTemplateTypes';
import { Col, Form, Nav, Row, Tab, Tabs } from 'react-bootstrap';
import i18n from '../../../../i18n';
import { buildBody, getBodyMatchers, getDetailTitle, MatcherBody } from '../../../../utils/TransactionDetailUtils';
import styles from '../TransactionSimpleDetail.module.css';
import { messageTypes } from '../../../../types/rest/dslTypes';
import _ from 'lodash';
import BlazeTable from '../../../blazeTable/BlazeTable';
import { BlazeTableColDef, BlazeTableOptions } from '../../../blazeTable/BlazeTable.types';

interface Props {
  transaction: MsgTransaction;
  context: MockService | MockServiceTemplate;
}

const MessagingSimpleViewTabs = (props: Props) => {
  const { requestDsl, responseDsl } = props.transaction.dsl;

  const bodyMatchers: MatcherBody[] = buildBody(requestDsl.body);

  const getRequestTabs = () => {
    return (
      <div className="p-4 bg-light">
        <Row></Row>
        {requestDsl.body.length === 0 && <p>{i18n.t('transactions:editor.nonEmptyListMessage')}</p>}
        {requestDsl.body.length > 0 && getBodyMatchers(bodyMatchers)}
      </div>
    );
  };

  const getContent = (content: string) => {
    if (!_.isEmpty(content)) {
      try {
        return atob(content);
      } catch (e) {
        return null;
      }
    }
  };

  const headersColDefinition: BlazeTableColDef[] = [
    {
      header: 'Name',
      accessor: 'name',
    },
    {
      header: 'Value',
      accessor: 'value',
    },
  ];

  const responsePropertiesColDefinition: BlazeTableColDef[] = [
    ...headersColDefinition,
    {
      header: 'Type',
      accessor: 'type',
    },
  ];

  const getTableOptions = (columnDefinition: BlazeTableColDef[]): BlazeTableOptions => ({
    columnDef: columnDefinition,
    pageable: false,
    selectable: false,
    isRowExpandable: () => false,
    showRowExpander: false,
    customTableClassName: 'flex-table-simple flex-table-condensed',
  });

  const getResponseTabs = () => {
    return (
      <div className="p-4 bg-light">
        <Row>
          <div className={styles.titleResponseTab}>
            <Form.Label>{i18n.t('transactions:editor.messageType')}:</Form.Label>
          </div>
          <div>
            <span className={styles.value} id="qa-txn-simple-detail-resp-sc">
              {messageTypes[responseDsl.messageType]}
            </span>
          </div>
        </Row>
        <Tab.Container defaultActiveKey="response-body">
          <Nav variant="tabs">
            <Nav.Item>
              <Nav.Link eventKey="response-body">
                {getDetailTitle(
                  i18n.t('transactions:editor.bodyTitle'),
                  !_.isEmpty(responseDsl.content)
                    ? `${i18n.t('transactions:editor.defined')}`
                    : `${i18n.t('transactions:editor.notDefined')}`,
                )}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="response-headers">
                {getDetailTitle(
                  i18n.t('transactions:editor.headersTitle'),
                  _.size(responseDsl.headers) !== 0 ? `${_.size(responseDsl.headers)}` : `0`,
                )}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="response-properties">
                {getDetailTitle(
                  'Response Properties',
                  _.size(responseDsl.properties) !== 0 ? `${_.size(responseDsl.properties)}` : `0`,
                )}
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="response-body">
              {responseDsl.content && (
                <Row className="mb-3">
                  <Col>
                    {!responseDsl.binary && <Form.Label>{i18n.t('transactions:editor.rawBody')}</Form.Label>}
                    {responseDsl.binary && (
                      <React.Fragment>
                        <Form.Label>{i18n.t('editor.binaryBody')}</Form.Label>
                        <div className="float-right">{i18n.t('transactions:editor.shortBinaryDescription')}</div>
                      </React.Fragment>
                    )}
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="content"
                      value={getContent(responseDsl.content)}
                      readOnly={true}
                    />
                  </Col>
                </Row>
              )}
              {!responseDsl.content && <p className={'mt-4'}>{i18n.t('transactions:editor.noResponseBody')}</p>}
            </Tab.Pane>

            <Tab.Pane eventKey={'response-headers'}>
              {_.size(responseDsl.headers) === 0 ? (
                <p className={'mt-4'}>{i18n.t('transactions:editor.noResponseHeaders')}</p>
              ) : (
                <BlazeTable options={getTableOptions(headersColDefinition)} data={responseDsl.headers} />
              )}
            </Tab.Pane>

            <Tab.Pane eventKey={'response-properties'}>
              {_.size(responseDsl.properties) === 0 ? (
                <p className={'mt-4'}>No Response Properties</p>
              ) : (
                <BlazeTable options={getTableOptions(responsePropertiesColDefinition)} data={responseDsl.properties} />
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  };

  return (
    <Tabs className="mb-0">
      <Tab title={'Request'} eventKey="request">
        {getRequestTabs()}
      </Tab>
      <Tab title={'Response'} eventKey="response">
        {getResponseTabs()}
      </Tab>
    </Tabs>
  );
};

export default MessagingSimpleViewTabs;
